import { useFirebaseData } from '../../@shared/hooks/useFirebaseData';
import { Collections } from '../../@core/constants/FirebasePaths';
import { IOrderMessage } from '../../@core/interfaces/IOrderMessage';

interface IProps {
  loadData?: boolean;
  reservationId?: string;
}

export const useOrderMessages = ({ loadData = false, reservationId }: IProps) => {
  const messagesPath = reservationId ? `${Collections.reservations._path}/${reservationId}/${Collections.reservations.messages}` : null;
  const db = useFirebaseData<IOrderMessage>({
    collectionPath: messagesPath,
    loadData,
    queries: [
      { type: 'orderBy', field: 'createdAt', direction: 'asc' }
    ]
  });

  const addMessage = async (message: Partial<IOrderMessage>) => {
    await db.update(reservationId, { newMessages: true }, Collections.reservations._path);
    return await db.add({ ...message });
  };

  const getMessages = async () => {
    if (!reservationId) return [];
    return await db.collectionWithIds<IOrderMessage>();
  };

  return {
    messages: db.data,
    addMessage,
    getMessages,
    fetched: db.fetched
  };
};
